import EmailSubscription from './components/emailSubscription';
import register from './components/register';
import howToUse from './components/howToUse';
import lozad from 'lozad'
import {pickSubscription} from './components/pickSubscription';
import {gtagButtonClick, pageView} from './inc/gtag';
import VrSystems from './components/vrSystems';
import Nav from './components/nav';
import Cookies from './components/cookies';
import Trainers from './components/trainers';
import BillingBlock from './components/billing-block';
import animation from './inc/animation';

window.preventVRClose = false;

window.confirmedFreeQuantity = false;

window.addEventListener('DOMContentLoaded', () => {
  window.observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  pageView();
  Cookies();

  EmailSubscription();
  register();
  howToUse().init();
  pickSubscription();
  VrSystems();
  Nav();
  Trainers();
  BillingBlock();
  animation();

  if (document.querySelectorAll('.swiper').length) {
    import(
      /* webpackChunkName: "swiper" */
      './inc/swiper').then(module => {
      const swiper = module.default;

      swiper();
    });
  }

  const websiteButtons = document.querySelectorAll('button, a');

  websiteButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      let id = button.getAttribute('id')
      const dataId = button.getAttribute('data-id')

      if (dataId) {
        id = dataId
      } else {
        id = id ? id : button.innerText.toLowerCase().replaceAll(' ', '-')
      }

      gtagButtonClick(id);
    })
  });

  const readMoreBtns = document.querySelectorAll('.readMore');

  readMoreBtns.forEach((readMoreBtn) => {
    readMoreBtn.addEventListener('click', (e) => {
      const sectionID = readMoreBtn.getAttribute('data-target');
      const section = document.querySelector(`[id^='${sectionID}']`);

      if (section) {
          window.scrollTo({
              top: section.offsetTop,
              behavior: 'smooth',
          })
      }
    })
  });

  const accordionToggleButtons = document.querySelectorAll('.fitxr-accordion-toggler');

  accordionToggleButtons.forEach((accordionToggleButton) => {
      accordionToggleButton.addEventListener('click', (e) => {
          e.preventDefault();

          accordionToggleButton.parentNode.classList.toggle('expanded')
          const accordionContent = accordionToggleButton.parentNode.querySelector('.fitxr-accordion-content');

          if (accordionContent) {
              accordionContent.classList.toggle('active');
          }
      })
  })
});


/*jQuery(document)
  .ready(function () {

    jQuery(document).trigger('scroll');
    return;
  })

function updateStudiosWidth() {
  let windowWidth = jQuery(window).width();
  let $section = jQuery('.sudios-block');
  let $studioItems = $section.find('.studio-item');

  if (windowWidth >= 1024) {
    let $container = $section.find('.container').eq(0);
    let containerWidth = $container.width();
    let studioWidthAdd = (windowWidth - containerWidth) / 2;
    $studioItems.css({width: containerWidth + studioWidthAdd});
    return;
  }

  $studioItems.css({width: windowWidth});
}

function updateTrainersWrapperWidth() {
  let windowWidth = jQuery(window).width();
  let $trainersWrapper = jQuery('.modal-trainers-inner');

  if (windowWidth >= 1024) {
    let $container = $trainersWrapper.closest('.container');
    let containerWidth = $container.width();
    let trainersWidthAdd = (windowWidth - containerWidth) / 2;
    $trainersWrapper.css({width: containerWidth + trainersWidthAdd});
    return;
  }

  $trainersWrapper.css({width: windowWidth});
}*/
